<section>
  <vdw-header [title]="'ANGULAR_COMPONENT_LIBRARY.RELOAD_REQUIRED.TITLE' | bmsTranslate" svgIcon="warning-blue"></vdw-header>

  <article class="dialog-content">
    <p class="b1">{{ 'ANGULAR_COMPONENT_LIBRARY.RELOAD_REQUIRED.DESCRIPTION' | bmsTranslateAsync | async }}</p>
  </article>

  <vdw-footer chooseEventName="ANGULAR_COMPONENT_LIBRARY.RELOAD_REQUIRED.RELOAD" [centered]="true" [withCancelButton]="false" (chooseEvent)="reloadApp()"> </vdw-footer>
</section>
